// extracted by mini-css-extract-plugin
export default {"TextOutlineControlsContainer":"TextOutlineControls_TextOutlineControlsContainer__XdJcg"};